'use client';

import { useMemo } from 'react';

import { useScreenName } from '../../../../hooks/use-screen-name';
import {
  getResponsiveValue,
  type ResponsiveValue,
  type ScreenName,
} from '../../../../utils';

import { Video } from './Video';

import type { VideoProps } from './Video';
import type { FC} from 'react';

export type ResponsiveVideoProps = Omit<VideoProps, 'src' | 'poster'> & {
  src?: ResponsiveValue<VideoProps['src']>;
  poster?: ResponsiveValue<VideoProps['poster']>;
  ssrScreen?: ScreenName;
};

/**
 * A responsive proxy for the `Video` component.
 */
export const ResponsiveVideo: FC<ResponsiveVideoProps> = props => {
  const { src: srcArg, poster: posterArg, ssrScreen, ...rest } = props;

  const screen = useScreenName(ssrScreen);
  const src = useMemo(
    () => getResponsiveValue(srcArg, undefined, screen),
    [srcArg, screen],
  );
  const poster = useMemo(
    () => getResponsiveValue(posterArg, undefined, screen),
    [posterArg, screen],
  );

  return <Video {...rest} src={src} poster={poster} />;
};
